import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@commonNodeModules/@ngx-translate/core';

@Component({
	selector: 'app-footer-content',
	imports: [TranslatePipe, NgClass],
	templateUrl: './footer-content.component.html',
	styleUrl: './footer-content.component.scss'
})
export class FooterContentComponent {
	@Input() darkTheme = true;
	public infoLinkKeyParts = ["about-us", "contact", "media-data"];
	public serviceLinkKeyParts = ["manufacturer", "property-consultant", "software-vendor"];


}
